import { AppResponse } from '@/modules/core/interfaces/appResponse';
import { ApiResponse } from 'modules/auth/interfaces/apiResponse';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
export class DashboardApi {
  public async recentClients(clientsNumber: number, actingBrokerId?: number | null): Promise<any> {
    const endpointUrl = `/broker/clients/last/${ clientsNumber }`;

    let config: AxiosRequestConfig = {};

    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }

    const response: AxiosResponse<ApiResponse<
      any
    >> = await AuthorizedApiClient.get(endpointUrl, config);

    if (response.status) {
      const result: ApiResponse<any> = response.data;

      if (result.success) {
        return result.data.clients;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }
  public async recentMessages(
    userId?: number | null,
    companyId?: number | null,
    page: number = 0,
    recordsPerPage: number = 10,
    actingBrokerId?: number | null,
  ): Promise<any> {
    const endpointUrl = '/message/last';
    const json = {
      userId,
      companyId,
      page,
      recordsPerPage
    };
    let config: AxiosRequestConfig = {};
    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }
    const response: AxiosResponse<ApiResponse<
      any
    >> = await AuthorizedApiClient.post(endpointUrl, json, config);

    if (response.status) {
      const result: ApiResponse<any> = response.data;

      if (result.success) {
        return result.data || { data: [], count: 0, hasNext: false };
      } else {
        return { data: [], count: 0, hasNext: false };
      }
    } else {
      return { data: [], count: 0, hasNext: false };
    }
  }

  public async getMortgagesSummary(actingBrokerId?: number | null): Promise<any[]> {
    let config: AxiosRequestConfig = {};
    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }

    const response: AxiosResponse<AppResponse<
      any[]
    >> = await AuthorizedApiClient.get('/broker/mortgages-summary', config);


    if (response.status) {
      const result: AppResponse<any[]> = response.data;

      if (result.success) {
        return result.data;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  public async getProtectionCasesSummary(actingBrokerId?: number | null): Promise<number> {
    let config: AxiosRequestConfig = {};
    if (actingBrokerId) {
      config = {
        headers: {
          'X-Acting-Broker-Id': actingBrokerId,
        },
      };
    }

    const response: AxiosResponse<AppResponse<
      { count: number }
    >> = await AuthorizedApiClient.get('/broker/protection-cases-summary', config);

    if (response.status) {
      const result: AppResponse<{ count: number }> = response.data;

      if (result.success) {
        return result.data.count;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }
}
